<template>
  <div class="class-list">
    <GlobalInfoBar
      title="换新账户账单"
    >
      <div class="balance" slot="rightSlot">
        <!-- <div class="flex" v-if="isNicePay">
          <div class="tag blue">门店商家</div>
          <span>{{companyAccount.name}}账户余额：</span>
          <span style="color:#FB7B7B">￥{{companyAccount.balance}}</span>
        </div>
        <div class="flex" style="margin-top:8px" v-if="isNicePay">
          <div class="tag yellow">靓机回收商</div>
          <span>{{niceMerchantAccount.name}}账户余额：</span>
          <span style="color:#FB7B7B">￥{{niceMerchantAccount.balance}}</span>
        </div> -->
        <div class="flex" style="margin-top:8px">
          <div class="tag red">换新账户</div>
          <span>当前账户余额：{{ nowBalance }}元</span>
        </div>
      </div>
      <div slot="rightSlot">
        <span class="costInto" @click="shiftBillInto">充值提醒</span>
        <span class="cost" @click="shiftBill">账户调账</span>
      </div>
    </GlobalInfoBar>
    <!-- <Info/> -->
    <GlobalChunk icon="search" title="筛选查询">
      <div slot="filter">
        <From :accountType="accountType" :info="info" @refresh="getCompanyAccount"/>
      </div>
      <Table :accountType="accountType" @billNumber="billNumber" ref="table"/>
    </GlobalChunk>
    <!--弹框-->
    <el-dialog title="资金账户调整" :visible.sync="dialogVisible" :close-on-click-modal="false"
      width="500px" @closed="handleDialogClosed">
      <div class="flex accountForm">
        <div class="tagBlue">换新账户</div>
        <span>当前账户余额：{{ nowBalance }}元</span>
      </div>
      <el-form class="balance-form" ref="form" :model="transferData" :rules="transferRules" label-width="100px">
        <el-form-item label="调账到：">
          <el-radio-group v-model="transferData.account">
            <el-radio label="01">回收账户</el-radio>
            <!-- <el-radio label="02">换新账户</el-radio> -->
          </el-radio-group>
        </el-form-item>
        <el-form-item label="调账金额：" prop="amountPrice">
          <el-input size="small" placeholder="请输入调账金额" maxlength="10" @input="limitInput($event)"
            v-model.trim="transferData.amountPrice"></el-input>
          <span v-if="NumMoney" style="color:#F83232;font-weight: bold;">{{
            NumMoney
          }}</span>
        </el-form-item>
        <el-form-item label="调账原因：" prop="cause">
          <el-input
              maxlength="50"
              type="textarea"
              show-word-limit
              :rows="3"
              placeholder="请输入调账原因,最多50字"
              v-model="transferData.cause"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div style="color:#0981FF; font-size:16px;margin-left: 30px">
        调账人：<span style="margin-left: 10px">{{ transferData.opeator }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native=handleDialogClosed>取消</el-button>
        <el-button type="primary" :loading="butLoading" @click.native="handleSuccess">确定</el-button>
      </span>
    </el-dialog>
    <!--弹框-->
    <el-dialog title="充值提醒" :visible.sync="dialogIntoVisible" :close-on-click-modal="false"
      width="500px" @closed="handleDialogClosed">
      <div style="color:#FB7B7B;margin-bottom:10px;" >
       当余额低于预警值时，系统将自动发生充值提醒到对应人员手机号
      </div>
      <el-form class="balance-form" ref="accountForm" :model="accountData" :rules="accountRules" label-width="110px">
        <el-form-item label="预警值：" prop="amountPrice">
          <div style="display: flex;" >
            <el-input class="warning" :disabled="isEditAmount" size="small" placeholder="请输入调账金额" maxlength="6"
              v-model.number="accountData.amountPrice" ></el-input>
            <div class="account">元<span class="text-down editAcc" @click="isEditAmount = false">修改</span></div>
          </div> 
        </el-form-item>
        <el-form-item label="提醒手机号：" prop="phone">
          <el-input size="small" placeholder="请输入手机号" maxlength="11" @input="limitInput($event)"
            v-model.trim="accountData.phone"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="handleDialogClosed">取消</el-button>
        <el-button type="primary" :loading="butLoading" @click.native="handleAccSuccess">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import From from "./Form";
import Table from "./Table";
import _api from "@/utils/request";
import {formValidateMobile} from '@/utils/form-validate'
export default {
  name: "class-list",
  components: {
    From,
    Table
  },
  data() {
    return {
      isEditAmount:true,
      dialogVisible: false,
      dialogIntoVisible:false,
      butLoading: false,
      NumMoney: "",
      transferData: {
        account:"01",
        amountPrice: "",
        cause:"",
        opeator:""
      },
      transferRules:{
        amountPrice: [
          {
            required: true,
            trigger: "blur",
            message: "请输入调账金额",
          },
        ],
        cause: [
          {
            required: true,
            trigger: "blur",
            message: "请输入调账原因",
          },
        ],        
      },
      accountData:{
        amountPrice:0,
        phone:"",
      },
      accountRules:{
        amountPrice:[
          {
            required: true,
            trigger: "blur",
            message: "请输入预警值",
          },
          { pattern: /^[1-9]\d*$/, message: '请输入正整数',trigger: 'blur' }
        ],
        phone: [
          {
            required: true,
            validator: formValidateMobile,
            trigger: 'change'
          }
        ],
      },
      nowBalance:0,
      clickShow: '01',
      accountType: "merchant",
      billNumberObj: {},
      accountCopyData:{
        amountCopyPrice:0,
        copyPhone:"",
      },
      isOpenRenewSubsidy: null,
      isNicePay: false,
      info: {
        companyAccount: {
          name: "",
          balance:"",
        },
        niceMerchantAccount: {
          name: "",
          balance:"",
        },
      }
    };
  },
  created() {
    this.getCompanyAccount()
  },
  methods: {
    // 调账
    shiftBill() {
      this.dialogVisible = true
      this.transferData.account = '01'
      this.transferData.opeator = localStorage.getItem("userName")
    },
    shiftBillInto() {
      this.dialogIntoVisible = true
    },
    handleDialogClosed() {
      this.dialogVisible = false
      this.dialogIntoVisible = false
      this.transferData = {
        account:"02",
        amountPrice: "",
        cause:"",
        opeator:""
      },
      this.NumMoney = ""
      if(this.$refs.form){
        this.$refs["form"].resetFields()
      }else{
         this.$refs["accountForm"].resetFields()
      }
      this.$emit('refresh')
    },
    limitInput(value) {
      let str = (value && value.split("")) || [];
      let reg1 = /\d/;
      let reg2 = /\./;
      // 第一个字符不能为小数点
      if (str[0] == ".") {
        this.transferData.amountPrice = "";
        return;
      }
      // 过滤掉除数字和小数点外的字符
      value = str.filter((e) => reg1.test(e) || reg2.test(e));
      // 匹配小数点后只能有两位小数
      let valJoin = value.join("");
      this.transferData.amountPrice = valJoin.match(/^\d*(\.?\d{0,2})/g)[0] || null;
      if (this.transferData.amountPrice > this.nowBalance) {
        this.transferData.amountPrice = this.nowBalance
      }
      this.NumMoney = this.transferData.amountPrice
        ? this.changeNumMoneyToChinese(this.transferData.amountPrice)
        : "";
    },
    // 金额大写
    changeNumMoneyToChinese(money) {
      var cnNums = new Array(
        "零",
        "壹",
        "贰",
        "叁",
        "肆",
        "伍",
        "陆",
        "柒",
        "捌",
        "玖"
      ); //汉字的数字
      var cnIntRadice = new Array("", "拾", "佰", "仟"); //基本单位
      var cnIntUnits = new Array("", "万", "亿", "兆"); //对应整数部分扩展单位
      var cnDecUnits = new Array("角", "分", "毫", "厘"); //对应小数部分单位
      var cnInteger = "整"; //整数金额时后面跟的字符
      var cnIntLast = "元"; //整型完以后的单位
      var maxNum = 999999999999999.9999; //最大处理的数字
      var IntegerNum; //金额整数部分
      var DecimalNum; //金额小数部分
      var ChineseStr = ""; //输出的中文金额字符串
      var parts; //分离金额后用的数组，预定义
      var Symbol = ""; //正负值标记
      if (money == "") {
        return "";
      }

      money = parseFloat(money);
      if (money >= maxNum) {
        alert("超出最大处理数字");
        return "";
      }
      if (money == 0) {
        ChineseStr = cnNums[0] + cnIntLast + cnInteger;
        return ChineseStr;
      }
      if (money < 0) {
        money = -money;
        Symbol = "负 ";
      }
      money = money.toString(); //转换为字符串
      if (money.indexOf(".") == -1) {
        IntegerNum = money;
        DecimalNum = "";
      } else {
        parts = money.split(".");
        IntegerNum = parts[0];
        DecimalNum = parts[1].substr(0, 4);
      }
      if (parseInt(IntegerNum, 10) > 0) {
        //获取整型部分转换
        var zeroCount = 0;
        var IntLen = IntegerNum.length;
        for (var i = 0; i < IntLen; i++) {
          var n = IntegerNum.substr(i, 1);
          var p = IntLen - i - 1;
          var q = p / 4;
          var m = p % 4;
          if (n == "0") {
            zeroCount++;
          } else {
            if (zeroCount > 0) {
              ChineseStr += cnNums[0];
            }
            zeroCount = 0; //归零
            ChineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
          }
          if (m == 0 && zeroCount < 4) {
            ChineseStr += cnIntUnits[q];
          }
        }
        ChineseStr += cnIntLast;
        //整型部分处理完毕
      }
      if (DecimalNum != "") {
        //小数部分
        var decLen = DecimalNum.length;
        for (let i = 0; i < decLen; i++) {
          let n = DecimalNum.substr(i, 1);
          if (n != "0") {
            ChineseStr += cnNums[Number(n)] + cnDecUnits[i];
          }
        }
      }
      if (ChineseStr == "") {
        ChineseStr += cnNums[0] + cnIntLast + cnInteger;
      } else if (DecimalNum == "") {
        ChineseStr += cnInteger;
      }
      ChineseStr = Symbol + ChineseStr;

      return ChineseStr;
    },
    handleAccSuccess(){
      this.$refs['accountForm'].validate((valid) => { 
        if(valid){
          let data = {
            companyId: this.companyId,
            warningPhone: this.accountData.phone,
            warningValue: this.accountData.amountPrice
          }
          if (data.warningPhone != '') {
            console.log('预警值',this.accountData.amountPrice);
            _api.findSetActivityWarnValue(data).then((res) => {
              if (res.code == 1) {
                this.$message.success(res.msg || "操作成功");
                this.handleDialogClosed()
                this.isEditAmount = true
                this.getCompanyAccount()
              }
            })
          } else {
            this.$message.error("请输入手机号");
          }
        }
      })
    },
     // 确认调账
    handleSuccess() {
      // if (!this.transferData.amountPrice) {
      //   this.$message.error("请输入调账金额");
      //   return;
      // }
      this.$refs["form"].validate((valid) => { 
      if(valid){
        let params = {
        cause:this.transferData.cause,
        operationAccount: this.transferData.account,
        amountPrice: Number(this.transferData.amountPrice),
      };
      this.butLoading = true;
      _api.adjustmentAccount(params)
        .then((res) => {
          if (res.code == 1) {
            console.log(123);
            this.$message.success(res.msg || "操作成功");
            this.handleDialogClosed()
            this.getCompanyAccount()
            this.$refs['table'].handleCurrentChange()
          }
          this.dialogVisible = false;
          this.butLoading = false;
        })
        .catch((err) => {
          if (err.msg == '账户余额不足') {
            this.transferData.amountPrice = ""
            this.NumMoney = ""
          }
          this.$emit('refresh')
          this.butLoading = false;
        });
         }
      })
    },
    billNumber(obj){
      this.billNumberObj=obj
    },
    //获取商家账户信息
    getCompanyAccount() {
      _api.getCompanyAccount().then(res => {
        if(res.code == 1){
          this.isNicePay = res.data.isNicePay
          this.companyAccount = res.data.companyAccount
          this.niceMerchantAccount = res.data.niceMerchantAccount
          this.info = res.data
          this.companyId = res.data.companyAccount.id
          this.nowBalance = res.data.companyAccount.activityBalance
          this.isOpenRenewSubsidy = res.data.isOpenRenewSubsidy
          this.accountData={
            amountPrice:res.data.companyAccount.activityWarningValue,
            phone:res.data.companyAccount.activityWarningPhone,
          }
        }
      })
    }
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.class-list{
  .button_top{
    cursor: pointer;
    margin-bottom: 20px;;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .faultBtn{
    width: 280px;
    height: 32px;
    background: #F9FBFD;
    border: 1px solid #C1D1FF;
    box-shadow: 0px 4px 8px 0px rgba(196, 197, 198, 0.2);
    border-radius: 21px;
    display: flex;
    .left{
      text-align: center;
      color: white;
      width: 50%;
      height: 14px;
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 30px;
      height: 30px;
      background: #0981FF;
      border-radius: 20px;
    }
    .right{
      text-align: center;
      color: #333;
      width: 50%;
      height: 14px;
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 30px;
      height: 30px;
      border-radius: 20px;
    }
  }
  .balance{
    display: flex;
    flex-direction: column;
    //flex: 1;
    margin-left: 20px;
    align-items: center;
    font-size: 14px;
    color: #666666;
    .tag{
      box-sizing: border-box;
      width: max-content;
      height: 16px;
      padding: 0 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      font-size: 12px;
      margin-right: 6px;
    }
    .tag.blue{
      color: #0981FF;
      border: 1px solid #0981FF;
    }
    .tag.yellow{
      color: #FFAA1D;
      border: 1px solid #FFAA1D;
    }
    .tag.red{
      color: #FB7B7B;
      border: 1px solid #FB7B7B;
    }
  }
  .cost{
    font-size: 16px;
    color:#FB7B7B;
    text-decoration: underline;
    cursor: pointer;
    margin-left: 20px;
  }
  .costInto{
    font-size: 16px;
    color:#0981FF;
    text-decoration: underline;
    cursor: pointer;
    margin-left: 20px;
  }
  .flex{
    display: flex;
    align-items: center;
  }
  .accountForm{
    margin-left: 20px;
    margin-bottom: 10px;
  }
  .tagBlue{
    box-sizing: border-box;
    width: max-content;
    height: 25px;
    line-height: 25px;
    padding: 0 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    font-size: 12px;
    margin-right: 15px;
    color: #FB7B7B;
    border: 1px solid #FB7B7B;
  }
  .text-down{
    color: #0981FF;
    text-decoration: underline;
    cursor: pointer;
  }
  .warning {
    width: 260px;
  }

  /deep/.warning .el-input__inner {
    padding: 0 5px;
  }
  .account{
    margin-left: 5px;
  }
  .editAcc{
    margin-left:40px;
  }
}
</style>
